import { render, staticRenderFns } from "./orderDetailInfo2.vue?vue&type=template&id=38f0dcee"
import script from "./orderDetailInfo2.vue?vue&type=script&lang=js"
export * from "./orderDetailInfo2.vue?vue&type=script&lang=js"
import style0 from "./orderDetailInfo2.vue?vue&type=style&index=0&id=38f0dcee&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38f0dcee')) {
      api.createRecord('38f0dcee', component.options)
    } else {
      api.reload('38f0dcee', component.options)
    }
    module.hot.accept("./orderDetailInfo2.vue?vue&type=template&id=38f0dcee", function () {
      api.rerender('38f0dcee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/order/components/orderDetailInfo2.vue"
export default component.exports